export default [
	{
      code:'BAL',
      label:'BAL - Fischbein',
    },
	{
      code:'BAR',
      label:'BAR - Rinde (Baumrinde)',
    },
    {
      code:'BOC',
      label:'BOC - geschnitzter Knochen',
    },
    {
      code:'BOD',
      label:'BOD - Körper',
    },
    {
      code:'BON',
      label:'BON - Knochen',
    },
    {
      code:'BOP',
      label:'BOP - Knochenstück',
    },
    {
      code:'CAL',
      label:'CAL - Calipee (schildkrötengallerte)',
    },
    {
      code:'CAP',
      label:'CAP - Carapacks (Panzer)',
    },
    {
      code:'CAR',
      label:'CAR - Schnitzerei',
    },
    {
      code:'CAV',
      label:'CAV - Kaviar',
    },
    {
      code:'CHP',
      label:'CHP - Holzspäne',
    },
    {
      code:'CLA',
      label:'CLA - Klaue',
    },
    {
      code:'CLO',
      label:'CLO - Tuch',
    },
    {
      code:'COM',
      label:'COM - Koralle (verarbeitet)',
    },
    {
      code:'COR',
      label:'COR - Koralle (roh)',
    },
	{
      code:'COS',
      label:'COS - Kosmetika, die Auszuege aus in der CITES-Liste gefuehrten Arten enthalten.',
    },
    {
      code:'CSM',
      label:'CSM - Kosmetika',
    },
    {
      code:'CUL',
      label:'CUL - Kultur',
    },
	{
      code:'DPL',
      label:'DPL - getrocknete Pflanze',
    },
    {
      code:'DER',
      label:'DER - Derivate (außer bereits anderweitig in dieser Tabelle erfasst)',
    },
    {
      code:'EAR',
      label:'EAR - Ohr',
    },
    {
      code:'EGG',
      label:'EGG - Kaviareier',
    },
    {
      code:'EGL',
      label:'EGL - Eier (lebend)',
    },
	{
      code:'ESH',
      label:'ESH - Eierschale',
    },
    {
      code:'EXT',
      label:'EXT - Extrakt',
    },
    {
      code:'FEA',
      label:'FEA - Feder',
    },
    {
      code:'FIB',
      label:'FIB - Faser',
    },
	{
      code:'FIN',
      label:'FIN - Flosse, Finne',
    },
	{
      code:'FIG',
      label:'FIG - Fingerling',
    },
	
    {
      code:'FLO',
      label:'FLO - Blume',
    },
    {
      code:'FOO',
      label:'FOO - Fuß',
    },
    {
      code:'FPL',
      label:'FPL - Fellprodukt (groß)',
    },
    {
      code:'FPS',
      label:'FPS - Fellprodukt (klein)',
    },
    {
      code:'FPT',
      label:'FPT - Blumentopf',
    },
    {
      code:'FRU',
      label:'FRU - Frucht',
    },
    {
      code:'GAB',
      label:'GAB - Gallenblase',
    },
    {
      code:'GAL',
      label:'GAL - Galle',
    },
    {
      code:'GAR',
      label:'GAR - Kleidungsstück',
    },
    {
      code:'GEN',
      label:'GEN - Genitalien',
    },
    {
      code:'GRS',
      label:'GRS - gepfropfter Wurzelstock',
    },
	{
      code:'GIL',
      label:'GIL - Kiemenplatten',
    },
    {
      code:'HAI',
      label:'HAI - Haar',
    },
	{
      code:'HAP',
      label:'HAP - Waren aus Haar',
    },
    {
      code:'HOC',
      label:'HOC - geschnitztes Horn',
    },
    {
      code:'HOP',
      label:'HOP - Hornstücke',
    },
    {
      code:'HOR',
      label:'HOR - Horn',
    },
    {
      code:'IJW',
      label:'IJW - Juwelen aus Elfenbein',
    },
    {
      code:'IVC',
      label:'IVC - geschnitztes Elfenbein',
    },
    {
      code:'IVP',
      label:'IVP - Elfenbeinstücke',
    },
    {
      code:'JWL',
      label:'JWL - Juwelen',
    },
    {
      code:'KEY',
      label:'KEY - Klaviertasten',
    },
    {
      code:'LEG',
      label:'LEG - Froschschenkel',
    },
    {
      code:'LIV',
      label:'LIV - lebend',
    },
    {
      code:'LOG',
      label:'LOG - Baumstämme (geschlagen)',
    },
    {
      code:'LPL',
      label:'LPL - Lederprodukt',
    },
    {
      code:'LPS',
      label:'LPS - Lederprodukt (klein)',
    },
    {
      code:'LVS',
      label:'LVS - Blatt',
    },
    {
      code:'MEA',
      label:'MEA - Fleisch',
    },
    {
      code:'MED',
      label:'MED - Arznei',
    },
    {
      code:'MUS',
      label:'MUS - Moschus',
    },
    {
      code:'OIL',
      label:'OIL - Öl',
    },
    {
      code:'PLA',
      label:'PLA - Pelzdecken',
    },
	{
      code:'POW',
      label:'POW - Puder',
    },
    {
      code:'PLY',
      label:'PLY - Sperrholz',
    },
	{
      code:'PRL',
      label:'PRL - Perle (z. B. von Strombus gigas)',
    },
	{
      code:'PUP',
      label:'PUP - Schmetterlingspuppen',
    },
	{
      code:'ROO',
      label:'ROO - Wurzel',
    },
    {
      code:'ROS',
      label:'ROS - Saegefisch-Rostrum',
    },
    {
      code:'RUG',
      label:'RUG - Teppich',
    },
    {
      code:'SAL',
      label:'SAL - Sägestämme',
    },
    {
      code:'SAW',
      label:'SAW - Sägeholz',
    },
    {
      code:'SCA',
      label:'SCA - Schuppen',
    },
    {
      code:'SEE',
      label:'SEE - Samen',
    },
    {
      code:'SHE',
      label:'SHE - Schalen',
    },
    {
      code:'SID',
      label:'SID - Seite',
    },
    {
      code:'SKE',
      label:'SKE - Skelett',
    },
    {
      code:'SKI',
      label:'SKI - Haut',
    },
    {
      code:'SKP',
      label:'SKP - Hautstück',
    },
    {
      code:'SKU',
      label:'SKU - Schädel',
    },
    {
      code:'SOU',
      label:'SOU - Suppe',
    },
    {
      code:'SPE',
      label:'SPE - Probe (wissenschaftlich)',
    },
    {
      code:'STE',
      label:'STE - Stamm',
    },
	{
      code:'SWI',
      label:'SWI - Schwimmblase',
    },
    {
      code:'TAI',
      label:'TAI - Schwanz',
    },
    {
      code:'TEE',
      label:'TEE - Zahn',
    },
    {
      code:'TIM',
      label:'TIM - Holz',
    },
    {
      code:'TRO',
      label:'TRO - Trophäe',
    },
    {
      code:'TRU',
      label:'TRU - Rüssel',
    },
    {
      code:'TUS',
      label:'TUS - Stoßzahn',
    },
    {
      code:'VEN',
      label:'VEN - Furnierholz (Rundschälfurnier)',
    },
    {
      code:'WAX',
      label:'WAX - Wachs',
    },
    {
      code:'WHO',
      label:'WHO - Ganzes Exemplar',
    },
    {
      code:'WPR',
      label:'WPR - Holzprodukt',
    },
];